<div
  appScrollList
  [activeIndex]="(activeCategoryIndex$ | async) ?? 0"
  *ngIf="{
    isSearching: isSearching$ | async,
    items: items$ | async
  } as data"
>
  <ng-container *ngIf="data.items">
    <ng-container *ngIf="!!data.items?.size || (activeFilterCount$ | async) === 0; else emptyByFilter">
      <div
        class="menu-section"
        appObserver
        [intersectionOptions]="intersectionOptions"
        (leaveEnd)="leaveEnd(category.slug, data.isSearching)"
        appScrollItem
        *ngFor="let category of categories$ | async"
        [attr.data-category-slug]="category.slug"
      >
        <div class="menu-section__head">
          <div class="menu-section__title h1">{{ category.name }}</div>
          <div class="menu-section__schedule" *ngIf="category.currentAvailableRange as schedule">
            <div class="menu-section__caption">
              <span i18n="@@AvailableFrom">Available from</span> {{ schedule.from }} <span i18n="@@To">to</span> {{ schedule.to }}
            </div>
          </div>
        </div>
        <div class="menu-section__list">
          <div class="menu-section__item" #productCard [attr.uniqKey]="item.uniqKey" *ngFor="let item of data.items.get(category.id)">
<!--            <app-product-card *ngIf="visibilityMap.get(item.uniqKey); else cardPlaceholder" [data]="item"></app-product-card>-->
            <app-product-card [data]="item"></app-product-card>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-template #emptyByFilter>
    <div class="h4 empty-message" i18n="@@NoDishesByFilter">No dishes found for the selected filters. Try changing the conditions.</div>
  </ng-template>

</div>

<ng-template #cardPlaceholder>
  <div class="product-card-placeholder"></div>
</ng-template>

<router-outlet></router-outlet>
